import { AuthorizationHeaderKey } from "../model/header-key";
import { BASE_PATH } from "./base";
const VERIFY_TOKEN_PATH = BASE_PATH + "/verify-token";
const AUTHORIZE_PATH = BASE_PATH + "/authorize";
export const addAuthorizationToHeader = (headers) => {
    headers.set(AuthorizationHeaderKey, localStorage.getItem("token") || "");
};
export const verifyToken = async () => {
    const response = await fetch(VERIFY_TOKEN_PATH, {
        method: "GET",
        headers: {
            [AuthorizationHeaderKey]: localStorage.getItem("token") || "",
        },
    });
    if (response.status === 200) {
        return true;
    }
    else {
        return false;
    }
};
export const authorize = async (password) => {
    const response = await fetch(AUTHORIZE_PATH, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
    });
    if (response.status === 200) {
        const data = await response.json();
        const token = data.token;
        if (token) {
            localStorage.setItem("token", token);
        }
        return true;
    }
    else {
        return false;
    }
};
